import { ResponseModel, handleGetAsync, handlePostAsync, handlePutAsync, handleDeleteAsync } from "../../components/common/commonclass";
import { EndPoint } from "../../components/common/config";
import { handleNotify, TOASTER_POSITION, TOASTER_TYPE } from "../../components/common/notification/toaster_notify.component";

var responseModel = new ResponseModel();

export class UserRolesService {
    // Get All 
    static async getAllUserRoles() {
        responseModel = new ResponseModel();
        const requestURL = EndPoint.USERROLE; // endpoint

        responseModel = await handleGetAsync(requestURL, true);
        if (responseModel) {
            return responseModel;
        } else {
            console.error('Failed to fetch user roles.');
            return [];
        }
    }

    // Create 
    static async addNewUserRole(data) {
        responseModel = new ResponseModel();
        const requestURL = EndPoint.USERROLE; // endpoint

        responseModel = await handlePostAsync(requestURL, true, data);

        if (responseModel) {
            handleNotify('User Role added successfully!', TOASTER_TYPE.SUCCESS, TOASTER_POSITION.TOP_RIGHT);
            return responseModel;
        } else {
            throw new Error('Failed to create new user role.');
        }
    }

    // Get by ID
    static async getUserRoleById(id) {
        responseModel = new ResponseModel();
        const requestURL = `${EndPoint.USERROLE}/${id}`; // endpoint

        responseModel = await handleGetAsync(requestURL, true);
        if (responseModel) {
            return responseModel;
        } else {
            throw new Error('Failed to fetch user role by ID');
        }
    }

    // Update
    static async updateUserRoleById(id, data) {
        responseModel = new ResponseModel();
        const requestURL = `${EndPoint.USERROLE}/${id}`; // endpoint

        responseModel = await handlePutAsync(requestURL, true, data);
        if (responseModel) {
            handleNotify('User Role updated successfully.', TOASTER_TYPE.SUCCESS, TOASTER_POSITION.TOP_RIGHT);
            return responseModel;
        } else {
            throw new Error('Failed to update user role.');
        }
    }

    // Delete
    static async deleteUserRole(id) {
        responseModel = new ResponseModel();
        const requestURL = `${EndPoint.USERROLE}/${id}`; // endpoint

        try {
            responseModel = await handleDeleteAsync(requestURL, true);
            if (responseModel) {
                handleNotify('User Role deleted successfully.', TOASTER_TYPE.SUCCESS, TOASTER_POSITION.TOP_RIGHT);
                return responseModel;
            } else {
                throw new Error('Failed to delete user role.');
            }
        } catch (error) {
            console.error('Error deleting user role:', error);
            throw error;
        }
    }

    // Delete Multiple 
    static async deleteManyUserRoles(ids) {
        responseModel = new ResponseModel();
        const requestURL = `${EndPoint.USERROLE}/deletemany`; // endpoint

        try {
            responseModel = await handleDeleteAsync(requestURL, true, ids);
            if (responseModel) {
                handleNotify(responseModel.message, TOASTER_TYPE.SUCCESS, TOASTER_POSITION.TOP_RIGHT);
                return responseModel;
            } else {
                handleNotify(responseModel.errormessage, TOASTER_TYPE.ERROR, TOASTER_POSITION.TOP_RIGHT);
            }
        } catch (error) {
            console.error('Error deleting multiple user roles:', error);
            throw error;
        }
    }
}
